import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8ce8084a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "base-navigation-component" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-6" }
const _hoisted_5 = {
  key: 0,
  class: "steps-container d-flex"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-6 d-flex justify-content-end" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "logo-theme" })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (!_ctx.hideNavigation)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.totalSteps, (index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["step", { selected: _ctx.selectedStep == index }]),
                    key: index
                  }, null, 2))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]),
        _hoisted_6
      ])
    ])
  ]))
}